export const formatedData = (number) => {
  if ((!isFinite(number) || isNaN(number)) && typeof number !== 'string') {
    number = 0
  }
  if (typeof number === 'string') {
    number = number.replace('R$', '').replace(',', '.')
  }

  return new Intl.NumberFormat('pt-BR', {
    maximumFractionDigits: 2,
    style: 'currency',
    minimumFractionDigits: 2,
    currency: 'BRL',
  }).format(number)
}
